import { FormControl, Select, MenuItem, Typography, SxProps, Theme, InputLabel } from "@mui/material";
import React, { useContext } from "react";
import { useToggle } from "../../hooks/useToggle";
import { useTenants } from "../../hooks/useTenants";
import { TenantContext } from "../../context/TenantContextProvider";
import { useLocalStorage } from "../../utils/localStorage";

const textEllipsisStyle: SxProps<Theme> = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export function CompanySelector() {
  const { tenant, updateTenant } = useContext(TenantContext);
  const { tenants, isLoading } = useTenants();
  const [menuVisible, openMenu, closeMenu] = useToggle(false);
  const [isUpdating, startUpdating, endUpdating] = useToggle(false);
  const storage = useLocalStorage();

  if (isLoading || !tenants.length || !tenant) return null;

  const onCompanySelect = async (id: string) => {
    try {
      startUpdating();
      await updateTenant(id);
      storage?.setItem(storage.keys.tenant, id);
      // Clear any stored suggested chasable filters when switching company
      storage?.removeItem(storage.keys.suggestedChasableFilters);
    } catch (e) {
      console.error(e);
    } finally {
      endUpdating();
    }
  };

  return (
    <FormControl variant="filled" fullWidth={true}>
      <InputLabel id="company-select-label">Company</InputLabel>
      <Select
        labelId="company-select-label"
        id="company-select"
        open={menuVisible}
        onOpen={openMenu}
        onClose={closeMenu}
        value={tenant}
        disabled={isUpdating}
        renderValue={(selected) => {
          return <Typography sx={textEllipsisStyle}>{tenants?.find(({ id }) => id === selected)?.name}</Typography>;
        }}
      >
        {tenants.map((tenant) => (
          <MenuItem key={tenant.id} value={tenant.id} onClick={() => onCompanySelect(tenant.id)}>
            <Typography whiteSpace="wrap">{tenant.name}</Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
